import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"
import { useContext } from "react"
import { AuthContext } from "@/hooks/use-auth"
import { DEFAULT_TENANT_TIME_ZONE, organisationDay } from "@/lib/organisation-day"

/**
 * Fuseau de l'organisme, servi avec l'utilisateur. Paris hors session.
 * Jamais sur une page publique ou du portail.
 * L'utilisateur connecté n'y est pas l'organisme (`organisation-day-guard`).
 *
 * @example
 * useOrganisationTimeZone() // "Indian/Reunion"
 */
export function useOrganisationTimeZone(): string {
  return pipe(
    O.fromNullable(useContext(AuthContext)),
    O.chain((auth) => O.fromNullable(auth.user)),
    O.chain((current) => O.fromNullable(current.timezone)),
    O.getOrElse(() => DEFAULT_TENANT_TIME_ZONE),
  )
}

/**
 * Aujourd'hui pour l'organisme courant.
 *
 * @example
 * useOrganisationToday() // "2026-10-14"
 */
export function useOrganisationToday(): string {
  return organisationDay(new Date(), useOrganisationTimeZone())
}
